var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "overlay-dialog" },
    [
      _c("h2", {
        staticClass: "overlay-dialog__title",
        domProps: { innerHTML: _vm._s(_vm.$t("account.userDetailEdit.title")) }
      }),
      _vm._v(" "),
      _vm.response.message
        ? _c("GeneralMessage", {
            ref: "message",
            attrs: { message: _vm.response.message, type: _vm.response.type },
            on: {
              close: function($event) {
                _vm.response.message = ""
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("ValidationObserver", {
        ref: "form",
        attrs: { tag: "form", novalidate: "" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              var errors = ref.errors
              return [
                _c("ValidationProvider", {
                  staticClass: "input-wrapper",
                  attrs: {
                    name: "firstname",
                    rules: "required",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "text",
                                name: "firstname",
                                placeholder: _vm.$t("forms.labels.firstname"),
                                label: _vm.$t("forms.labels.firstname"),
                                error: invalid && validated,
                                disabled: _vm.disabled,
                                required: ""
                              },
                              on: { input: _vm.onInput },
                              model: {
                                value: _vm.form.userDetail.firstName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.userDetail,
                                    "firstName",
                                    $$v
                                  )
                                },
                                expression: "form.userDetail.firstName"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("ValidationProvider", {
                  staticClass: "input-wrapper",
                  attrs: {
                    name: "lastname",
                    rules: "required",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "text",
                                name: "lastname",
                                placeholder: _vm.$t("forms.labels.lastname"),
                                label: _vm.$t("forms.labels.lastname"),
                                error: invalid && validated,
                                disabled: _vm.disabled,
                                required: ""
                              },
                              on: { input: _vm.onInput },
                              model: {
                                value: _vm.form.userDetail.lastName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.userDetail, "lastName", $$v)
                                },
                                expression: "form.userDetail.lastName"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("ValidationProvider", {
                  ref: "registerEmail",
                  staticClass: "input-wrapper",
                  attrs: {
                    name: "email",
                    rules: "required|email",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                      email: _vm.$t("forms.errors.emailInvalid")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "email",
                                name: "email",
                                autocomplete: "email",
                                placeholder: _vm.$t("forms.labels.email"),
                                label: _vm.$t("forms.labels.email"),
                                error: invalid && validated,
                                disabled: _vm.disabled,
                                required: ""
                              },
                              on: { input: _vm.onInput },
                              model: {
                                value: _vm.form.userDetail.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.userDetail, "email", $$v)
                                },
                                expression: "form.userDetail.email"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("ValidationProvider", {
                  staticClass: "input-wrapper",
                  attrs: {
                    name: "phone",
                    rules: "required|phone",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                      phone: _vm.$t("forms.errors.phone")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "tel",
                                name: "phone",
                                placeholder: _vm.$t("forms.labels.phone"),
                                label: _vm.$t("forms.labels.phone"),
                                error: errors.length > 0,
                                disabled: _vm.disabled,
                                required: ""
                              },
                              on: { input: _vm.onInput },
                              model: {
                                value: _vm.form.userDetail.phoneNumber,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.userDetail,
                                    "phoneNumber",
                                    $$v
                                  )
                                },
                                expression: "form.userDetail.phoneNumber"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "additional-info",
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("login.phoneHint"))
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    type: "submit",
                    level: "primary",
                    text: _vm.$t("account.userDetailEdit.save"),
                    disabled: _vm.loading
                  }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }